// extracted by mini-css-extract-plugin
export var back = "galerie-module--back--3KC45";
export var title = "galerie-module--title--2v2wx";
export var list = "galerie-module--list--a0fc5";